<script setup>
import { ref, onMounted, nextTick, watch } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

import EmptyState from './components/EmptyState.vue';
import Messages from './components/Messages.vue';
import ReplyBox from './components/ReplyBox.vue';

defineProps({
  previewVersion: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['togglePreview']);

const messages = useMapGetter('wgptBotKnowledgeManager/getMessages');

const conversationPanel = ref(null);

const scrollToBottom = () => {
  nextTick(() => {
    const panel = conversationPanel.value;
    if (panel) panel.scrollTop = panel.scrollHeight;
  });
};

onMounted(() => {
  scrollToBottom();
});

watch(
  () => messages.value.length,
  () => {
    scrollToBottom();
  }
);
</script>

<template>
  <div class="flex flex-col justify-between flex-grow h-full min-w-0 m-0">
    <div
      ref="conversationPanel"
      class="flex-shrink min-h-0 flex-grow basis-px flex flex-col overflow-y-auto h-full m-0 pt-8 pb-4 px-3"
    >
      <Messages
        v-if="messages.length > 0"
        :preview-version="previewVersion"
        :messages="messages"
        @toggle-preview="emit('togglePreview', $event)"
      />
      <EmptyState v-else />
    </div>

    <ReplyBox />
  </div>
</template>
